import { gql } from "@apollo/client";


export const GET_HOTLIST_PROPERTIES = gql`
query getHotListProperties($email_id: String!) {
	getHotListProperties(email_id: $email_id) {
		success
		message
		data {
			arcimedes_row_id
			address
			contact {
				contact_id
				contact_type
			}
		}
	}
}
`

export const GET_HOTLIST_PROPERTIES_BY_EMAIL = gql`
query hotlistPropertiesByEmail($email_id: String!) {
	hotlistPropertiesByEmail(email_id: $email_id) {
		success
		message
		data {
			arcimedes_row_id
            id
			name
			email_id
			hot_list_properties            
		}
	}
}
`
